
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import React, { Component } from "react";
//import DatePicker from "react-datepicker";
import banner from '../pics/banner.PNG';
import About from '../About/About';
import Select from 'react-select';
import { FaWhatsapp } from 'react-icons/fa';
import { ArrowLeft } from 'react-bootstrap-icons';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import axios from 'axios';
import { getAllCustomerRegistrations } from '../Utils/Utils';
import { LayoutDashboard, Menu } from 'lucide-react';
//import { redirect } from 'next/dist/server/api-utils';
class Ironfoldonly extends React.Component {
    constructor(props) {
        super(props);
        this.handleAboutOpen = React.createRef();
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            userid: "",
            servicedate: '', //new Date(),
            mycomments: '',
            loadweights: '',
            mobilePhone: '',
            address: '',
            area: '',
            totalamount: '0.00',
            shouldRedirect: false,
            fullname: "",
            emailaddress: "",
            phonenumber: "",
            token: "",
            gender: "",
            role: "",
            address: "",
            city: "",
            serviceType: "Iron & Fold Only",
            pricelists: [],
            weightlist: [],
            prices: [],
            customerslist: [],
            selectedCustomer: null,
            allcustomers: [],
            modifiedby: ""
        }
    }

    componentDidMount = async () => {
        if (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("token") === "") {
            this.setState({ shouldRedirect: true });
        }

        else {
            if (this.props.location.state.role !== "Admin") {
                document.getElementById("admincreateorder").style.display = "none";
            }
            const allcustomers = await getAllCustomerRegistrations();

            let customersOptions = [];
            allcustomers.forEach(customer => {
                customersOptions.push({ label: customer.fullname, value: customer.id });
            });
            this.setState({
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, modifiedby: this.props.location.state.fullname,
                phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role, address:
                    this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city,
                userid: this.props.location.state.userid, pricelists: await this.getPriceList(), customerslist: customersOptions, allcustomers: allcustomers
            })
        }
    }
    getPriceList = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "iwash_laundry", "pricelist": "ironfoldonly" }
        }
       // const url = "http://localhost/iwash-php/api/getPriceList.php";
        //const url = "https://testmembership.bktsystems.com/api/UAT_getPriceList.php";
        const url = "https://testmembership.bktsystems.com/api/getPriceList.php";
        const response = await axios.get(url, config);

        const ironfoldonlylist = response.data.weightlist;
        const ironfoldonlyprice = response.data.ironfoldonlyprice;

        try {
            // 2. Convert the text string into a real JavaScript array
            const parsedironfoldonlylist = new Function(`return ${ironfoldonlylist};`)();

            // 3. Save the actual array to your state
            this.setState({ weightlist: parsedironfoldonlylist, prices: response.data.ironfoldonlyprice });
        } catch (error) {
            console.error("Failed to parse JSON string:", error);
            this.setState({ weightlist: [], prices: [] }); // Fallback to empty array if parsing fails
        }

        return response.data;
    }

    openAbout = () => {
        this.setState({ about: "about" });
        this.handleAboutOpen.current.handleAboutOpen();
    }

    goBackToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/home', {
            state: {
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, phonenumber: this.props.location.state.phonenumber, gender: this.props.location.state.gender,
                role: this.props.location.state.role, address: this.props.location.state.address, city: this.props.location.state.city, area: this.props.location.state.area,
                userid: this.props.location.state.userid
            }
        });
    }

    handleCommentsChange = (e) => {
        // console.log(e.target.value);
        this.setState({
            mycomments: e.target.value

        });
    }
    todayISO = new Date().toISOString().slice(0, 10);

    handleServiceDateChange = (event) => {
        this.setState({
            servicedate: event.target.value
        });
        //console.log(event.target.value);
    }
    setPhoneNumber = (e) => {
        const limitedPhone = e.target.value;
        if (limitedPhone.length > 10) {
            alert("Phone number cannot exceed 10 digits");
        }
        this.setState({ mobilePhone: limitedPhone });
    }
    setAddress = (e) => {
        this.setState({ address: e });
    }

    setClothingWeightsChange = (e) => {

        const prices = JSON.parse(this.state.prices);
        this.setState({ loadweights: e, totalamount: prices[e].toFixed(2) });
    }

    createOrder = async () => {
        // Implement order creation logic here, such as sending data to the backend API
        let config = {
            headers: { 'Content-Type': 'application/json' },
            params: {
                userid: this.state.userid,
                fullname: this.state.fullname,
                emailaddress: this.state.emailaddress,
                phonenumber: this.state.phonenumber,
                address: this.state.address,
                area: this.state.area,
                servicedate: this.state.servicedate,
                loadweights: this.state.loadweights,
                totalamount: this.state.totalamount,
                notes: this.state.mycomments,
                servicetype: this.state.serviceType,
                modifiedby: this.props.location.state.fullname
            }
        };

        if (this.state.servicedate === "" || this.state.phonenumber === "" || this.state.address === "" || this.state.area === "" ||
            this.state.loadweights === "") {
            alert("Please fill in all required fields before creating the order.");
            return;
        }
        else {
            // const url = "http://localhost/iwash-php/api/createOrder.php";
            // const url = "https://testmembership.bktsystems.com/api/UAT_createOrder.php";
            const url = "https://testmembership.bktsystems.com/api/createOrder.php";
            const response = await axios.get(url, config);
            //  console.log(response.data);
            if (response.data.includes("Success")) {
                document.getElementById("btnSubmit").style.display = "none";
                document.getElementById("successCreate").style.display = "block";
                document.getElementById("errorCreate").style.display = "none";
                this.setState({
                    servicedate: '', mycomments: '', loadweights: '', totalamount: '0.00', userid: "", fullname: "", emailaddress: "",
                    phonenumber: "", address: "", area: ""
                });
            }
            else {
                document.getElementById("errorCreate").style.display = "block";
            }
        }
    }

    handleCloseOrderForm = () => {
        // this.setState({ register: "", customeremail: "", customerphonenumber: "", customerfullname: "" });
        document.getElementById("btnSubmit").style.display = "none";
        this.props.navigate('/trackorder', {
            state: {
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, phonenumber: this.props.location.state.phonenumber, gender: this.props.location.state.gender,
                role: this.props.location.state.role, address: this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city, userid: this.props.location.state.userid
            }
        });
    }
    setCustomerChange = (customerId) => {

        const selectedCustomer = this.state.allcustomers.find(customer => customer.id === customerId);

        this.setState({
            selectedCustomer: selectedCustomer, phonenumber: selectedCustomer.phonenumber, address: selectedCustomer.address,
            area: selectedCustomer.area, city: selectedCustomer.city, fullname: selectedCustomer.fullname, emailaddress: selectedCustomer.emailaddress,
            userid: selectedCustomer.id, modifiedby: this.props.location.state.fullname
        });
    }

    clothingWeights = [
        { label: "5-10Kgs", value: "5-10Kgs" },
        { label: "10-20Kgs", value: "10-20Kgs" },
        { label: "20-30Kgs", value: "20-30Kgs" },
        { label: "30-40Kgs", value: "30-40Kgs" },
        { label: "40-50Kgs", value: "40-50Kgs" },
        { label: "50+Kgs", value: "50+Kgs" }
    ]
    customStyles = {
        control: (provided) => ({
            ...provided,
            height: '50px', 
            borderBottom: "2px solid darkblue"
        })
    }

    render() {
        if (this.state.shouldRedirect === true || this.props.location.state === null || this.props.location.state === undefined) {
            return <Navigate to="/" replace />;
        }
        return (
            <>
                <div style={{
                    height: "100%", margin: "0", padding: "0", paddingLeft: "10px", paddingRight: "10px", fontFamily: "lora"// backgroundColor: "#e0ded5" 
                }}>
                    <div className='mainDivHome' style={{
                        paddingTop: "5vh", border: '2px solid #f0eee4', borderRadius: "10px",
                        backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '250px'
                    }}>
                        <div style={{
                            paddingTop: "10px", paddingBottom: "10px", textAlign: "center", color: "white", fontSize: "25px", fontWeight: "bold",
                            textShadow: "2px 2px 4px #000000"
                        }}>

                            <span style={{ fontStyle: "italic" }}><label>iWash Laundry Solutions </label></span><br />
                            <span style={{ fontStyle: "italic" }}><label>Logged in as {(this.state.fullname).split(" ")[0]} </label></span><br />
                            {/* <span style={{ fontStyle: "italic" }}><label>{this.state.date}</label></span> */}
                        </div>
                    </div>
                    <div style={{ textAlign: "center", paddingTop: "2vh" }}>
                        <span variant="primary" style={{//backgroundColor: "#e0ded5",
                            border: "none", paddingTop: "2vh", height: "60px", paddingBottom: "1vh", display: "flex", width: "100%", borderRadius: "10px",
                        }} onClick={this.goBackToMenu}>
                            <label style={{
                                 textAlign: "center", fontStyle: "italic", color: "darkblue",
                                fontWeight: "bold", textShadow: "1px 1px 2px grey", fontSize: "18px"
                            }}><ArrowLeft color="darkblue" size={40} /> IRON - FOLD ONLY</label>
                        </span>
                    </div>
                    <div id="admincreateorder" style={{ paddingTop: "15px", fontSize: "18px" }}>
                        <FormGroup>
                            <Label for='selectcustomer' style={{ color: "darkblue", fontStyle: "italic" }}>Customer name</Label>
                            <Select
                                styles={this.customStyles}
                                options={this.state.customerslist || []}
                                onChange={opt => this.setCustomerChange(opt.value)}
                            ></Select>
                        </FormGroup>
                    </div>
                    <div style={{ paddingTop: "15px", fontSize: "18px" }}>
                        <FormGroup>
                            <Label style={{ color: "darkblue", fontStyle: "italic" }} for='servicedate'>Service date</Label>
                            <Input style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                type='date'
                                selected={this.state.servicedate}
                                onChange={this.handleServiceDateChange}
                                min={this.todayISO}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label style={{ color: "darkblue", fontStyle: "italic" }} for='phonenumber'>Phone number</Label>
                            <Input style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                // customStyles: StylesConfig = {{height:'40px', borderBottom:"2px solid darkblue"}}
                                type='number'
                                id='phonenumber'
                                name='phonenumber'
                                placeholder="07234567896"
                                value={this.state.phonenumber}
                                readOnly={true}
                                onChange={this.setPhoneNumber}
                                min={10}
                                max={10}

                            />
                        </FormGroup>
                        <FormGroup>
                            <Label style={{ color: "darkblue", fontStyle: "italic" }} for="areacity">Area</Label>
                            <Input style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                type="text"
                                value={this.state.area + ', ' + this.state.city}
                                onChange={(e) => this.setarea(e.target.value)}
                                placeholder="Enter your area"
                                readOnly={true}
                                autoComplete="street-address"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label style={{ color: "darkblue", fontStyle: "italic" }} for="address">Address</Label>
                            <Input style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                type="text"
                                value={this.state.address}
                                onChange={(e) => this.setAddress(e.target.value)}
                                placeholder="Enter your address"
                                readOnly={true}
                                autoComplete="street-address"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label style={{ color: "darkblue", fontStyle: "italic" }} for='clothingweights'>Select weight</Label>
                            <Select styles={this.customStyles}
                                options={this.state.weightlist || []}
                                maxMenuHeight="100%"
                                defaultInputValue=""
                                onChange={opt => this.setClothingWeightsChange(opt.label)}
                            // styles={this.customStyles}
                            ></Select>
                        </FormGroup>
                        <FormGroup>
                            <Label style={{ color: "darkblue", fontStyle: "italic" }} for="comments">Notes / special instructions</Label>
                            <Input style={{borderBottom: "2px solid darkblue" }}
                                type="textarea"
                                id="mycomments"
                                name="mycomments"
                                rows="2"
                                value={this.state.mycomments}
                                onChange={this.handleCommentsChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label style={{ color: "darkblue", fontStyle: "italic" }} for='totalamount'>Total amount (R)</Label>
                            <Input style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                type='text'
                                id='totalamount'
                                name='totalamount'
                                placeholder="0.00"
                                value={this.state.totalamount}
                                readOnly
                            />
                        </FormGroup>
                        <div id="successCreate" style={{ display: "none", textAlign: "center", color: "green", fontWeight: "bold" }}>
                            <FormGroup>
                                <Label>Your order has been created successfully! Thank you for choosing our service.&#128591;</Label>
                            </FormGroup>
                        </div>
                        <div id="errorCreate" style={{ display: "none", textAlign: "center", color: "red", fontWeight: "bold" }}>
                            <FormGroup>
                                <Label>Sorry, there was an error submitting your order. Please try again &#128533;</Label>
                            </FormGroup>
                        </div>
                        <div id="btnSubmit" style={{ paddingTop: "10px" }}>
                            <Button style={{ backgroundColor: "rgba(30, 104, 40, 1)", height: "60px", width: "100%", color: 'white', fontWeight: "bold" }} onClick={this.createOrder}>Create Order</Button>
                        </div>
                        <div id="btnCloseOrderForm" style={{ paddingTop: "20px", paddingBottom: "20px" }}>
                            <Button style={{ width: "100%", fontWeight: "bold", height: "60px" }}
                                onClick={this.handleCloseOrderForm} color="danger">
                                Close
                            </Button>
                        </div>
                        <div style={{
                            borderTop: "1px solid #ccc", textAlign: "center", fontSize: "14px", color: "#666", height: "100%",
                            backgroundColor: "#f0eee4", border: "solid 0px #e8cf4f", borderRadius: "10px", paddingTop: "10px", paddingBottom: "10px"
                        }}>
                            <p>&copy; {new Date().getFullYear()} HudumaSoft. All rights reserved</p>
                            <div>
                                <Button style={{
                                    backgroundColor: "transparent", border: "none", color: "blue", fontSize: "16px", cursor: "pointer",
                                    fontWeight: "bold", textDecoration: "underline"
                                }}
                                    onClick={this.openAbout}>About Us
                                </Button>
                                | <a href="https://wa.me/+27796372245" rel="noopener noreferrer" target="_blank" title="Call or WhatsApp us!"> <FaWhatsapp size={35} color="#25D366" /></a>

                            </div>
                        </div>
                        <div>
                            <About
                                ref={this.handleAboutOpen}
                                onAboutClose={this.onAboutClose}
                            />
                        </div>
                    </div>
                </div>
            </>)
    }
}
export default withNavigateHook(Ironfoldonly);